import { useEffect, useState, useRef } from "react";
import { Row, Form, Col, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  InputControl,
  InputValidationConstants,
  SubmitButtonContent,
  TextAreaControl,
  SelectControl,
  TinymceControl,
  createOptionsFromEnum,
  Modal,
  Loading,
  NumberControl,
  CheckboxControl,
  DateTimeControl,
  PageHeader,
} from "wup-module1-base";
import {
  RoutePathConstants,
  QuestionTypeEnum,
  DisplayTypeEnum,
} from "../../../Constants";
import { v4 as uuidv4 } from "uuid";
/**
 * Komponent strony dodawania parametru raportu
 */
function AnswerModal({
  isEdit = null,
  answer = null,
  setAnswer,
  minValue = null,
  maxValue = null,
  rowNr = null,
  displayType = null,
  answers,
  setAnswers,
}) {
  const {
    register,
    getValues,
    setValue,
    reset,
    trigger,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const answerType = watch("type");
  const value = watch("value");

  useEffect(() => {
    if (!!answer) {
      reset(answer);
      setTimeout(trigger, 0);
    }
  }, [answer, reset]);

  useEffect(() => {
    setTimeout(trigger, 0);
  }, [answerType, value]);

  const onSubmit = () => {
    const data = getValues();
    const toSubmit = {
      ...data,
      id: answer.id,
      questionId: answer.questionId,
      isPredefined: false,
      relatedAnswerId: null,
    };
    setIsSubmitting(true);
    if (!isEdit) {
      const multipleAnswers = [];
      if (
        parseInt(data.type) === QuestionTypeEnum.OptionList.value ||
        parseInt(data.type) === QuestionTypeEnum.Mixed.value
      ) {
        const splitted = data.value.split(/\r?\n/);
        splitted.forEach((ans, idx) => {
          const trimmed = ans.trim();
          const objToAdd = {
            id: uuidv4(),
            type: data.type,
            questionId: answer.questionId,
            value: trimmed.startsWith("--", 0)
              ? trimmed.substr(2).trim()
              : trimmed,
            isPredefined: false,
            relatedAnswerId: trimmed.startsWith("--", 0)
              ? multipleAnswers[idx - 1].id
              : null,
          };
          multipleAnswers.push(objToAdd);
        });
        const appended = [...answers, ...multipleAnswers];
        setAnswers(appended);
      }
      // else if () {
      //   const splitted = data.value.split(/\r?\n/);
      //   splitted.forEach((ans) => {
      //     const objToAdd = {
      //       id: uuidv4(),
      //       type: data.type,
      //       questionId: answer.questionId,
      //       value: ans.trim(),
      //       isPredefined: false,
      //     };
      //     multipleAnswers.push(objToAdd);
      //   });
      // }
      else {
        const appended = [...answers, toSubmit];
        setAnswers(appended);
      }
    } else {
      // const foundAnswer = answerFields.find((i) => i.id === answer.id);
      // const answerIdx = answerFields.indexOf(foundAnswer);
      // updateAnswer(answerIdx, toSubmit);
      const foundAnswer = answers.find((i) => i.id === answer.id);
      const answerIdx = answers.indexOf(foundAnswer);
      answers[answerIdx] = toSubmit;
      setAnswers(answers);
    }
    setIsSubmitting(false);
    setAnswer(null);
  };

  return (
    <Modal
      show={!!answer}
      size={"default"}
      title={`${isEdit ? "Edycja" : "Dodawanie"} odpowiedzi`}
      onConfirm={onSubmit}
      onCancel={() => setAnswer(null)}
      confirmButtonText={
        isSubmitting ? (
          <Loading size="sm" className="px-2" variant="light" />
        ) : isEdit ? (
          "Zapisz"
        ) : (
          "Dodaj"
        )
      }
      confirmButtonDisabled={!isValid || isSubmitting}
      enforceFocus={true}
    >
      <Form>
        <Row>
          <Col md={12}>
            <SelectControl
              id={"type"}
              label={"Typ odpowiedzi"}
              readOnly={true}
              options={createOptionsFromEnum(QuestionTypeEnum, false)}
              refs={{
                ...register("type", {
                  required: InputValidationConstants.required,
                }),
              }}
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          {answerType &&
            parseInt(answerType) === QuestionTypeEnum.Date.value && (
              <>
                <Col md={12}>
                  <DateTimeControl
                    id={"value"}
                    label={"Odpowiedź"}
                    required={true}
                    type="date"
                    // min={!!minValue ?? null}
                    // max={!!maxValue ?? null}
                    refs={{
                      ...register("value", {
                        required: InputValidationConstants.required,
                        min: !!minValue
                          ? {
                              value: minValue,
                              message: `Data nie może być wcześniejsza niż ${minValue}`,
                            }
                          : null,
                        max: !!maxValue
                          ? {
                              value: maxValue,
                              message: `Data nie może być późniejsza niż ${maxValue}`,
                            }
                          : null,
                      }),
                    }}
                    errors={errors}
                  />
                </Col>
              </>
            )}
          {answerType &&
            parseInt(answerType) === QuestionTypeEnum.Number.value && (
              <>
                <Col md={12}>
                  <NumberControl
                    id={"value"}
                    label={"Odpowiedź"}
                    // min={minValue ?? 1}
                    // max={maxValue ?? 99999}
                    refs={{
                      ...register("value", {
                        required: InputValidationConstants.required,
                        min: {
                          value: !!minValue ? minValue : 1,
                          message: `Liczba nie może być mniejsza niż ${
                            !!minValue ? minValue : 1
                          }`,
                        },
                        max: !!maxValue
                          ? {
                              value: maxValue,
                              message: `Liczba nie może być większa niż ${maxValue}`,
                            }
                          : null,
                      }),
                    }}
                    errors={errors}
                  />
                </Col>
              </>
            )}
          {answerType &&
            parseInt(answerType) === QuestionTypeEnum.Text.value &&
            (parseInt(displayType) ===
            DisplayTypeEnum.Text_MultipleLines.value ? (
              <>
                <Col md={12}>
                  <TextAreaControl
                    id={"value"}
                    label={"Odpowiedź"}
                    readOnly={false}
                    rows={!!rowNr ? rowNr : 3}
                    refs={{
                      ...register("value", {
                        required: InputValidationConstants.required,
                        maxLength: {
                          value: !!maxValue ? maxValue : 512,
                          message: InputValidationConstants.maxLength.replace(
                            "{placeholder}",
                            !!maxValue ? maxValue : 512
                          ),
                        },
                        minLength: {
                          value: !!minValue ? minValue : 1,
                          message: InputValidationConstants.minLength.replace(
                            "{placeholder}",
                            !!minValue ? minValue : 1
                          ),
                        },
                      }),
                    }}
                    errors={errors}
                  />
                </Col>
              </>
            ) : (
              <>
                <Col md={12}>
                  <InputControl
                    id={"value"}
                    label={"Odpowiedź"}
                    readOnly={false}
                    refs={{
                      ...register("value", {
                        required: InputValidationConstants.required,
                        maxLength: {
                          value: !!maxValue ? maxValue : 54,
                          message: InputValidationConstants.maxLength.replace(
                            "{placeholder}",
                            !!maxValue ? maxValue : 54
                          ),
                        },
                        minLength: {
                          value: !!minValue ? minValue : 1,
                          message: InputValidationConstants.minLength.replace(
                            "{placeholder}",
                            !!minValue ? minValue : 1
                          ),
                        },
                      }),
                    }}
                    errors={errors}
                  />
                </Col>
              </>
            ))}
          {answerType &&
            parseInt(answerType) === QuestionTypeEnum.OptionList.value &&
            (isEdit ? (
              <>
                <Col md={12}>
                  <InputControl
                    id={"value"}
                    label={"Odpowiedź"}
                    readOnly={false}
                    refs={{
                      ...register("value", {
                        required: InputValidationConstants.required,
                      }),
                    }}
                    errors={errors}
                  />
                </Col>
              </>
            ) : (
              <>
                <Col md={12}>
                  <TextAreaControl
                    id={"value"}
                    label={"Odpowiedzi (oddziel nowymi liniami)"}
                    readOnly={false}
                    rows={!!rowNr ? rowNr : 10}
                    refs={{
                      ...register("value", {
                        required: InputValidationConstants.required,
                        maxLength: {
                          value: !!maxValue ? maxValue : 512,
                          message: InputValidationConstants.maxLength.replace(
                            "{placeholder}",
                            !!maxValue ? maxValue : 512
                          ),
                        },
                      }),
                    }}
                    errors={errors}
                  />
                </Col>
              </>
            ))}
          {answerType &&
            parseInt(answerType) === QuestionTypeEnum.YesNoSelect.value && (
              <>
                <Col md={12}>
                  <InputControl
                    id={"value"}
                    label={"Odpowiedź obligatoryjna"}
                    readOnly={false}
                    refs={{
                      ...register("value", {
                        required: InputValidationConstants.required,
                      }),
                    }}
                    errors={errors}
                  />
                </Col>
              </>
            )}
          {answerType &&
            parseInt(answerType) === QuestionTypeEnum.Mixed.value &&
            (isEdit ? (
              <>
                <Col md={12}>
                  <InputControl
                    id={"value"}
                    label={"Odpowiedź"}
                    readOnly={false}
                    refs={{
                      ...register("value", {
                        required: InputValidationConstants.required,
                      }),
                    }}
                    errors={errors}
                  />
                </Col>
              </>
            ) : (
              <>
                <Col md={12}>
                  <TextAreaControl
                    id={"value"}
                    label={
                      "Odpowiedzi (oddziel nowymi liniami - rozpocznij od znaków '--' w przypadku wyś. kaskadowego/warunkowego)"
                    }
                    readOnly={false}
                    rows={!!rowNr ? rowNr : 10}
                    refs={{
                      ...register("value", {
                        required: InputValidationConstants.required,
                        maxLength: {
                          value: !!maxValue ? maxValue : 512,
                          message: InputValidationConstants.maxLength.replace(
                            "{placeholder}",
                            !!maxValue ? maxValue : 512
                          ),
                        },
                      }),
                    }}
                    errors={errors}
                  />
                </Col>
              </>
            ))}
        </Row>
      </Form>
    </Modal>
  );
}

export default AnswerModal;
